import ArchiveIcon from "@/assets/icons/menu-archive.svg";
import DraftsIcon from "@/assets/icons/menu-draft.svg";
import InboxIcon from "@/assets/icons/menu-inbox.svg";
import SentIcon from "@/assets/icons/menu-sent.svg";
import SpamIcon from "@/assets/icons/menu-spam.svg";
import TrashIcon from "@/assets/icons/menu-trash.svg";
import MailSource from "@/domain/enums/MailSource";

const generalMailsIcons = [
    { id: MailSource.Inbox, icon: InboxIcon },
    { id: MailSource.Archive, icon: ArchiveIcon },
    { id: MailSource.SentItems, icon: SentIcon },
    { id: MailSource.Drafts, icon: DraftsIcon },
    { id: MailSource.JunkEmail, icon: SpamIcon },
    { id: MailSource.Deleteditems, icon: TrashIcon },
];

export default generalMailsIcons;
